export { default } from './StaticStyle';
